"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toyota = exports.Lexus = void 0;
var _styledComponents = require("styled-components");
var _LexusTypography = require("../../../../components/LexusTypography");
var _ToyotaTypography = require("../../../../components/ToyotaTypography");
var Styled = _interopRequireWildcard(require("./index.styled"));
const Lexus = exports.Lexus = (0, _styledComponents.css)`
  ${Styled.Checkbox} {
    height: 15px;
    width: 15px;
    border: 2px solid rgb(164, 139, 91);
    border-radius: 0;
  }

  ${Styled.CompareVehicleToggle} {
    & > span {
      text-transform: uppercase;
      ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "link13"
})}
    }
    input:checked + ${Styled.Checkbox} {
      background-color: rgb(164, 139, 91);
      border-color: rgb(164, 139, 91);
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAxUlEQVR42mJgoAy4ADEzJQaEAPEfIF5JrgFOQPwTiP8DcQU5BpgB8QeoAT3///8n2QAVIH4FNWAJEDOSaogMED+AGrARiNlAgqQYwg/El6AGnABiLpgEsiEgwQAcBnBBNf6HGiSALAkzhAmIdwPxPyDOQjOADep0kMqHUC8xYDMEBLKhhiAbxAgNvP/QwFTB5kz0MEE3qBdqwEcgNscVWNgCFtmg/9AE5YQvxHHFTjbUAJBBEYSiDV8UBwGxDzFxDzIEIMAA/I9LhQSgJbsAAAAASUVORK5CYII=);
    }
  }
`;
const Toyota = exports.Toyota = (0, _styledComponents.css)`
  ${Styled.Checkbox} {
    height: 24px;
    width: 24px;
    border: 1px solid #767676;
    border-radius: 3px;
  }

  ${Styled.CompareVehicleToggle} {
    & > span {
      ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "button01"
})}
    }
    input:checked + ${Styled.Checkbox} {
      background-color: #000;
      border-color: #000;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABbSURBVHgB5ZHBDcAgDAM9SkfoCB2BDdpNyMYdIeSBRISIhHkhcZJfzvkT4ExUNVkEK5j4auNi3F4WX9yW35JpuZaPKzMlu6NvNDIlRyOUHIxwcjAiWKF+JmF7Crxdwk/XprRkAAAAAElFTkSuQmCC);
    }
  }
`;